import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { sdk } from "./sdk"

export type Align = "left" | "center"
export type Section =
  | { id: string; hidden: boolean; type: "announcement"; settings: { text: string; link: string } }
  | { id: string; hidden: boolean; type: "hero"; settings: { heading: string; subheading: string; image: string; button_label: string; button_link: string; align: Align } }
  | { id: string; hidden: boolean; type: "featured_collection"; settings: { title: string; collection_handle: string; count: number } }
  | { id: string; hidden: boolean; type: "image_with_text"; settings: { heading: string; text: string; image: string; button_label: string; button_link: string; image_side: "left" | "right" } }
  | { id: string; hidden: boolean; type: "rich_text"; settings: { heading: string; body_html: string; align: Align } }
  | { id: string; hidden: boolean; type: "faq"; settings: { title: string; items: { q: string; a: string }[] } }
  | { id: string; hidden: boolean; type: "trust"; settings: { items: { title: string; text: string }[] } }

export type SectionType = Section["type"]
export const SECTION_LABELS: Record<SectionType, string> = {
  announcement: "Announcement bar",
  hero: "Hero banner",
  featured_collection: "Featured collection",
  image_with_text: "Image with text",
  rich_text: "Rich text",
  faq: "FAQ",
  trust: "Trust badges",
}

const newId = () => Array.from(crypto.getRandomValues(new Uint8Array(8)), (b) => "abcdefghijklmnopqrstuvwxyz0123456789"[b % 36]).join("")

export function newSection(type: SectionType): Section {
  const b = { id: newId(), hidden: false }
  switch (type) {
    case "announcement": return { ...b, type, settings: { text: "Free shipping on orders over $50", link: "" } }
    case "hero": return { ...b, type, settings: { heading: "Your headline", subheading: "", image: "", button_label: "Shop now", button_link: "/collections/all", align: "center" } }
    case "featured_collection": return { ...b, type, settings: { title: "Featured products", collection_handle: "", count: 8 } }
    case "image_with_text": return { ...b, type, settings: { heading: "Tell your story", text: "", image: "", button_label: "", button_link: "", image_side: "left" } }
    case "rich_text": return { ...b, type, settings: { heading: "", body_html: "<p></p>", align: "center" } }
    case "faq": return { ...b, type, settings: { title: "Frequently asked questions", items: [{ q: "", a: "" }] } }
    case "trust": return { ...b, type, settings: { items: [{ title: "Free returns", text: "30 days" }, { title: "Secure checkout", text: "" }] } }
  }
}

const KEY = ["content", "homepage"]
export const useHomepage = () => useQuery({ queryKey: KEY, queryFn: () => sdk.client.fetch<{ sections: Section[]; customized: boolean }>("/admin/terify/content/homepage") })
export function useSaveHomepage() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (sections: Section[]) => sdk.client.fetch<{ sections: Section[]; customized: boolean }>("/admin/terify/content/homepage", { method: "POST", body: { sections } }),
    onSuccess: (r) => qc.setQueryData(KEY, r),
  })
}
